<template>
  <div v-if="aspectRatio" class="wt-aspect-ratio-tag" :data-id="id">
    <div v-if="showRectangle" class="-rectangle" :style="rectangleStyleObj" />
    <div v-if="showLabel" class="-label" v-text="labelText" />
  </div>
</template>

<script>
import app from 'app';

export default {
  name: 'wt-aspect-ratio-tag',

  props: {
    id: { type: [Object, String], default: null },
    scale: { type: Number, default: 1 },
    showRectangle: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
  },

  data() {
    return {
      baseWidth: 20 /* px */,
      maxHeight: 20,
    };
  },

  computed: {
    aspectRatio() {
      return app.ASPECT_RATIOS[this.id];
    },

    rectangleStyleObj() {
      const maxHeight = this.scale * this.maxHeight;
      let width = this.scale * this.baseWidth;
      let height = width / this.aspectRatio.ratio;
      if (height > maxHeight) {
        width = maxHeight * this.aspectRatio.ratio;
        height = width / this.aspectRatio.ratio;
      }
      return {
        width: `${width}px`,
        height: `${height}px`,
      };
    },

    labelText() {
      return this.aspectRatio.friendlyVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-aspect-ratio-tag {
  display: flex;
  align-items: center;

  > .-rectangle {
    border: 1px solid $color-black;
    margin-right: 2px;
  }

  > .-label {
    font-size: 12px;
    line-height: 0;
  }
}
</style>
